import React, { useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import { BsArrowRight } from 'react-icons/bs';

import SME from '../../assets/images/sme3.png';
import Button from '../inputs/Button';

function SmeSchoolPopup() {
  const [showModal, setShowModal] = useState(false);

  const dismiss = () => setShowModal(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowModal(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {showModal ? (
        <div className="justify-center flex fixed inset-0 z-50 bg-black/60 p-2 md:p-0">
          <div className="relative w-full md:w-1/2 lg:w-1/3 p-9 m-auto bg-white rounded-lg text-start ">
            <MdClose className="absolute top-4 right-4 z-10 h-5 w-5 cursor-pointer" onClick={dismiss} />
            <img src={SME} alt="sme school seminar" className="rounded-lg w-full border border-[#c4c4c4]" />
            <h2 className="text-xl font-bold mt-5">Applications for the SME Business School 2026 in Ibadan</h2>
            <p className="text-[#6b7280] mt-3 text-sm">Hello, everyone. Application for the SME Business School 2026 has commenced.</p>
            <Button
              paddingY="py-2.5"
              className="bg-primary text-white mt-5"
            >
              <a className="flex gap-3 items-center" href="https://docs.google.com/forms/d/e/1FAIpQLSfpPnSNzKNXm5RrChtYCDLJwCbOlocWhrG9PBoTb2xZVZx0Qw/viewform" target="_blank" rel="noreferrer" onClick={dismiss}>
                <p>Click here to Apply</p>
                <BsArrowRight />
              </a>
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default SmeSchoolPopup;
